import React from "react";
import { Box, TextField, Typography } from "@mui/material";

/**
 * FASE 05 — Ajustes 25/08 (plano de mídias, item 12 do docx de 22/08).
 *
 * Campo "Nome do arquivo" das abas do Gerenciamento de Mídias. É ele que define com que nome
 * o arquivo é gravado — e o nome é o VÍNCULO entre o arquivo e os produtos: produtos que só
 * diferem pela cor compartilham o mesmo ícone/figura/ficha (decisão do PO em 26/08).
 *
 * Antes deste campo, o servidor renomeava tudo para um GUID e a tela mostrava esse GUID
 * acompanhado da query string do SAS — o "texto estranho" reportado em 25/08.
 */
interface CampoNomeArquivoProps {
  valor: string;
  onChange: (valor: string) => void;
  /** Extensões aceitas na aba, para a dica abaixo do campo (ex.: ".PNG, .JPG"). */
  extensoes: string;
  desabilitado?: boolean;
  /** Quantos OUTROS produtos já usam este nome — alimenta o aviso da Etapa D. */
  produtosCompartilhando?: number;
}

export const CampoNomeArquivo: React.FC<CampoNomeArquivoProps> = ({
  valor,
  onChange,
  extensoes,
  desabilitado,
  produtosCompartilhando,
}) => (
  <Box sx={{ mt: 2 }}>
    <TextField
      fullWidth
      size="small"
      label="Nome do arquivo"
      value={valor}
      onChange={(e) => onChange(e.target.value)}
      disabled={desabilitado}
      inputProps={{ maxLength: 200 }}
      helperText={`Com que nome o arquivo será gravado. Extensões aceitas: ${extensoes}.`}
    />
    {!!produtosCompartilhando && produtosCompartilhando > 0 && (
      // Reporte de 31/08 (item 6): o texto anterior só falava em substituir, e "não se aplica"
      // quando a intenção é o oposto — o produto em edição ASSUMIR a mídia de outro produto.
      // Agora a mensagem cobre os dois caminhos, porque os dois são possíveis nesta tela.
      <Typography variant="caption" sx={{ color: "#b26a00", display: "block", mt: 0.5 }}>
        Este nome já é usado por {produtosCompartilhando} outro(s) produto(s). Enviando um arquivo,
        a mídia de todos eles é substituída; informando apenas o nome, este produto passa a usar a
        mesma mídia, sem alterar os demais.
      </Typography>
    )}
  </Box>
);
